import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationSetting } from '../models';
import { BaseEditService } from './base';
import { BooleanStrings } from '../constants';
import { HttpService } from './http.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationSettingService extends BaseEditService<ApplicationSetting, ApplicationSetting> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ApplicationSetting', $localize`Application Setting`, httpService, notificationService);
  }

  get(key: string): Observable<string> {
    return this.httpService
      .get<ApplicationSetting>(`${this.apiUrl}?key=${key}`)
      .pipe(map((applicationSetting: ApplicationSetting) => applicationSetting?.value));
  }

  getBoolean(key: string): Observable<boolean> {
    return this.get(key).pipe(map((result) => result?.toUpperCase() === BooleanStrings.yes.toUpperCase()));
  }
}
